import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons' //faEnvelope, faDownload, 


export default function QuoteActionLinks({ productType }) {
   // const iconEmail = <FontAwesomeIcon icon={ faEnvelope } color="#00a8d5" />
   // const iconDownload = <FontAwesomeIcon icon={ faDownload } color="#00a8d5" />
   const iconPlus = <FontAwesomeIcon icon={ faPlus } color="#00a8d5" />
   const iconSearch = <FontAwesomeIcon icon={ faSearch } color="#00a8d5" />
   const isResinous = productType.toLowerCase().indexOf('resinous') > -1

   return (
      <div className={ isResinous ? "col-xs-12 col-sm-8 col-sm-pull-4 col-lg-pull-3 hidden-print" : "col-xs-12 hidden-print" }>
         <ul className={ isResinous ? "list-unstyled quote-action-links resinous-quote-action-links" : "list-unstyled quote-action-links" }>
            {/* <li><a href="# " className="email" data-bs-toggle="modal" data-bs-target="#modal-email">{ iconEmail } Email</a></li> */}
            {/* <li><a href="# " className="download">{ iconDownload } Download</a></li> */}
            <li><a href="# " className="new-quote" data-bs-toggle="modal" data-bs-target="#modal-new-quote">{ iconPlus } Create a New Quote</a></li>
            <li><a href="https://www.laticrete.com/en/where-to-buy" className="find-distributor" rel="noopener noreferrer" target="_blank">{ iconSearch } Find Distributor</a></li>
         </ul>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/QuoteActionLinks.js